import { getCountryFilePolicy } from 'shared/file/models/fileTypePolicy'
import { NctsError, NctsScope } from '../../../../../shared/ncts/types'
import { FileType } from '../../../models/schemas/fileSchemas'

export const FILE_TYPE_ERROR_CODE = 'FILE_TYPE'

const DOCUMENT_ARRAY_PATHS = ['previousDocument', 'supportingDocument', 'transportDocument']

type DocumentWithFiles = {
  files?: FileType[]
}

const hasFiles = (document: unknown): document is DocumentWithFiles => (
  typeof document === 'object' && document !== null && Array.isArray((document as DocumentWithFiles).files)
)

function validateDocumentFileTypes(formValues: object, country: string, scope: NctsScope): NctsError[] {
  const { isAcceptedFileType, allowedExtensions } = getCountryFilePolicy(country)
  const allowedSuffix = allowedExtensions === null ? '' : `. Accepted: ${allowedExtensions.join(', ')}`
  const errors: NctsError[] = []

  for (const documentPath of DOCUMENT_ARRAY_PATHS) {
    const documents = (formValues as Record<string, unknown>)[documentPath]
    if (!Array.isArray(documents)) {
      // eslint-disable-next-line no-continue
      continue
    }

    documents.forEach((document, documentIndex) => {
      if (!hasFiles(document)) return

      document.files?.forEach((file, fileIndex) => {
        if (file.deleted || isAcceptedFileType(file)) return

        errors.push({
          scope,
          path: `${documentPath}.${documentIndex}.files.${fileIndex}.fileName`,
          message: `File '${file.fileName}' is of a type ${country} customs do not accept${allowedSuffix}`,
          code: FILE_TYPE_ERROR_CODE,
        })
      })
    })
  }

  return errors
}

export default validateDocumentFileTypes
